<template>
  <div class="hitwrapper">
    <div class="hittitle">
      <a :id="hit.id" :href="hit.url">
        {{ hit.title }}
        <Icon type="arrow-right"/>
      </a>
    </div>
    <div class="contentfor" v-if="tags.length > 0">
      <div :id="'contentfor-' + hit.id" class="label">
        <span>{{ texts.innehallForDigSom }}</span>
      </div>
      <div>
        <Collapse
          ref="collapse"
          :id="'contentfor-collapse-' + hit.id"
          :showOnlyContent="tags.length <= 3"
        >
          <template #button-content-before-icon>
            <text :id="'contentfor-collapse-rubrik-' + hit.id">{{
              texts.gallerForManga
            }}</text>
          </template>
          <template #collapse-content>
            <ul :aria-labelledby="'contentfor-' + hit.id">
              <li v-for="tag in tags">{{ tag.text }}</li>
            </ul>
          </template>
        </Collapse>
      </div>
    </div>
    <p v-html="hit.excerpt"></p>
    <Breadcrumb
      v-if="this.showBreadcrumb"
      :id="hit.id"
      :breadcrumb="hit.breadcrumb"
    ></Breadcrumb>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
import Collapse from "../../../bootstrap/collapse.vue";
import Breadcrumb from "../../components/breadcrumb.vue";
export default {
  name: "PersonanpassadItem",
  props: {
    hit: Object,
    texts: Object,
    showBreadcrumb: Boolean,
  },
  components: {
    Collapse,
    Breadcrumb,
    Icon,
  },
  data: function () {
    return {
      tags: [],
    };
  },
  created() {
    this.setTags();
  },
  methods: {
    setTags: function () {
      if (this.hit.orgtags && this.hit.programtags) {
        this.tags = this.hit.orgtags.concat(this.hit.programtags);
      } else {
        this.tags = [];
      }
    },
  },
  watch: {
    hit: {
      deep: true,
      handler() {
        this.setTags();
      },
    },
  },
};
</script>
